var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-range-slider',{staticClass:"uk-margin",attrs:{"slug":_vm.data.slug,"label":_vm.data.label,"min":_vm.data.min,"max":_vm.data.max,"value":_vm.data.value}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-584770a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/catalog/assets/js/components/CatalogRangeFilter.vue
// module id = FZKF
// module chunks = 0